"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const nano_css_1 = require("nano-css");
const cache_1 = require("nano-css/addon/cache");
const stable_1 = require("nano-css/addon/stable");
const nesting_1 = require("nano-css/addon/nesting");
const atoms_1 = require("nano-css/addon/atoms");
const rule_1 = require("nano-css/addon/rule");
const drule_1 = require("nano-css/addon/drule");
const sheet_1 = require("nano-css/addon/sheet");
const dsheet_1 = require("nano-css/addon/dsheet");
const useStyles_1 = require("nano-css/addon/useStyles");
const jsx_1 = require("nano-css/addon/jsx");
const decorator_1 = require("nano-css/addon/decorator");
const keyframes_1 = require("nano-css/addon/keyframes");
const fadeIn_1 = require("nano-css/addon/animate/fadeIn");
const fadeInDown_1 = require("nano-css/addon/animate/fadeInDown");
const Normalize_1 = require("nano-css/addon/reset/Normalize");
const reset_font_1 = require("nano-css/addon/reset-font");
const googleFont_1 = require("nano-css/addon/googleFont");
const nano = nano_css_1.create({
    pfx: 'p4-',
    h: react_1.createElement,
});
exports.nano = nano;
cache_1.addon(nano);
stable_1.addon(nano);
nesting_1.addon(nano);
atoms_1.addon(nano);
rule_1.addon(nano);
drule_1.addon(nano);
sheet_1.addon(nano);
dsheet_1.addon(nano);
useStyles_1.addon(nano);
jsx_1.addon(nano);
decorator_1.addon(nano);
keyframes_1.addon(nano);
fadeIn_1.addon(nano);
fadeInDown_1.addon(nano);
googleFont_1.addon(nano);
exports.globalCss = () => {
    Normalize_1.addon(nano);
    reset_font_1.addon(nano);
};
const { put, rule, drule, sheet, keyframes, css } = nano;
exports.put = put;
exports.rule = rule;
exports.drule = drule;
exports.sheet = sheet;
exports.keyframes = keyframes;
exports.css = css;
const { dsheet, useStyles, jsx, googleFont } = nano;
exports.dsheet = dsheet;
exports.useStyles = useStyles;
exports.jsx = jsx;
exports.googleFont = googleFont;
//# sourceMappingURL=index.js.map